import Colorable from "@mixins/colorable";
import mixins from "@/core/util/mixins";

export default mixins(Colorable).extend({
  name: "TabsSlider",

  render(h) {
    return h(
      "div",
      this.setBackgroundColor(this.color, {
        staticClass: "TabsSlider"
      })
    );
  }
});
